import { createAction } from '@reduxjs/toolkit';

export const addUserOnline = createAction('userOnlineList/addUser');
export const removeUserOnline = createAction('userOnlineList/removeUser');
